<template>
  <div class="app-container">
    <Header></Header>
    <div class="top">
      <div class="title">大咖观点</div>
    </div>

    <div class="guest-list">
      <div class="guest-content">
        <div
          class="guest-item"
          v-for="(item, index) in nowBigView"
          :key="index"
        >
          <div class="info">
            <div class="photo"><img :src="item.coverImageUrl_new" /></div>
            <div class="name">
              <span>{{ item.title }}</span>
            </div>
            <div class="job ellipsis-2" v-html="item.position"></div>
          </div>
          <div class="content">
            <div class="desc">
              <span>{{ item.viewpoint }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <suspension></suspension>
    <cook-tip></cook-tip>
    <foot class="foot2"></foot>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import { staticApi } from "../../services";
import Suspension from "../../components/Suspension";
import { Swiper } from "vue-awesome-swiper";
var self;
export default {
  name: "BigView",
  data() {
    return {
      //guests: [],
      titleBgImg: require("@/assets/images/bigView/home/title.png"),
      ArrowUrl: require("@/assets/images/videos/arrow.png"),
      bigViews: [],
      nowBigView: [],
      page: 1, //当前页数
      pageSize: 10, //每页显示条数
    };
  },
  components: {
    Header,
    Foot,
    CookTip,
    Suspension,
  },
  computed: {},
  created() {},
  mounted() {
    self = this;
    //获取大咖观点列表
    this.getBigViews();
  },
  methods: {
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a class="prev_next">上一页</a>;
      } else if (type === "next") {
        return <a class="prev_next">下一页</a>;
      }
      return originalElement;
    },
    onChange(page) {
      this.page = page;
      this.nowBigView = this.bigViews.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
    },
    //获取大咖列表
    getBigViews() {
      this.$api
        .getStaticData(this.$config.bigViewId)
        .then((res) => {
          if (res.result == 0) {
            let bigviews = res.content.items;
            // bigviews = bigviews
            //   .filter((item) => {
            //     return item.isTop == 1;
            //   })

            for (let i = 0; i < bigviews.length; i++) {
              bigviews[i].coverImageUrl_new = "";
              if (bigviews[i].coverImageRealPath) {
                bigviews[i].coverImageUrl_new = bigviews[
                  i
                ].coverImageRealPath.replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              bigviews[i].position = bigviews[i].summary.substring(
                0,
                bigviews[i].summary.indexOf("SWITCH")
              );
              bigviews[i].viewpoint = bigviews[i].summary.substring(
                bigviews[i].summary.indexOf("SWITCH") + 6,
                bigviews[i].summary.length
              );
            }
            //bigviews.sort((a, b) => a.title.localeCompare(b.title)); //首字母A-Z排序
            bigviews = bigviews.sort((a, b) => {
              return b.order - a.order;
            });
            this.bigViews = bigviews;
            this.nowBigView = bigviews;
          }
        })
        .catch((err) => {
          console.log("获取大咖观点失败", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  @import "./css/index/pc.scss";
}
@media screen and (max-width: 992px) {
  @import "./css/index/wap.scss";
}
</style>
